import TextArea from "antd/lib/input/TextArea";
import { ContentText } from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import { ThemeTemplateItem } from "states/theme-template/theme-template.models";

export interface IThemeSettingTextNormalProps {
  model: any;
  template: ThemeTemplateItem;
  onChange: (changedModel: any) => void;
}

export function ThemeSettingTextNormal(props: IThemeSettingTextNormalProps) {
  const { model, template, onChange } = props;
  return (
    <div className="mt-2 mb-4">
      <div className="pb-2">
        <b>{template.name}</b>
      </div>
      <TextArea
        rows={4}
        placeholder={t(CoreResource, ContentText)}
        value={model?.value ?? ""}
        onChange={(ev: any) => {
          ev.preventDefault();
          onChange({ ...model, value: ev.target.value });
        }}
      />
    </div>
  );
}
